import React from 'react';
import { MdStar } from 'react-icons/md';
import './OneStarRatingThumbnail.css';

interface OneStarRatingThumbnailProps {
    rating?: number; // Value between 0 and 1, now optional
    numberOfRatings?: number;
}

const OneStarRatingThumbnail: React.FC<OneStarRatingThumbnailProps> = ({ rating, numberOfRatings = 0 }) => {
    // Check if rating is undefined or 0
    const isDisabled = rating === undefined || rating === 0;
    
    // Only calculate these if not disabled
    const normalizedRating = !isDisabled ? Math.max(0, Math.min(1, rating || 0)) : 0;
    // Calculate the fill degrees
    const fillDegrees = normalizedRating * 360; // Convert rating to degrees
    // For counterclockwise fill, we need to subtract the fill degrees from 360 - first set transparent empty, fill rest with yellow
    const emptyDegrees = 360 - fillDegrees;

    if (isDisabled) {
        return (
            <div className="one-star-rating-thumbnail-container">
                <div className="one-star-rating-thumbnail-background disabled">
                    <MdStar className="one-star-rating-thumbnail-icon disabled" />
                </div>
                <span className="one-star-rating-count">0x</span>
            </div>
        );
    }

    return (
        <div className="one-star-rating-thumbnail-container">
            <div className="one-star-rating-thumbnail-background">
                <MdStar className="one-star-rating-thumbnail-icon" />
            </div>
            <div 
                className="one-star-rating-thumbnail-fill" 
                style={{ 
                    background: `conic-gradient(transparent ${emptyDegrees}deg, #ffd700 ${emptyDegrees}deg)` 
                }}
            >
            </div>
            <span className="one-star-rating-count">{numberOfRatings}x</span>
        </div>
    );
};

export default OneStarRatingThumbnail; 